import { createFileRoute, redirect } from '@tanstack/react-router'
import {
  GlobalSearchParams,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { Route as NewRoute } from 'routes/system-lens/index'

export const Route = createFileRoute(
  '/system-lens/(deprecated_routes)/$siteID'
)({
  beforeLoad: ({ params }) => {
    const siteId = params.siteID

    throw redirect({
      to: NewRoute.to,
      search: (prev: Record<string, unknown> & GlobalSearchParams) => ({
        ...prev,
        [SEARCH_PARAM_SITE_ID]: siteId,
      }),
      replace: true,
    })
  },
})
